export type CalendarDisplayType = 'week' | 'day';

export const useCalendarDisplayType = (): CalendarDisplayType => {
  const { matches } = window.matchMedia('(min-width: 500px)');
  return matches ? 'week' : 'day';
};
